import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

const RecordHistorySkeleton: React.FC = () => (
  <div className="space-y-3">
    {Array.from({ length: 3 }).map((_, i) => (
      <div key={i} className="space-y-1">
        <Skeleton className="h-4 w-48" />
        <Skeleton className="h-3 w-72" />
      </div>
    ))}
  </div>
)
export default RecordHistorySkeleton
